<template>
  <tab-news
    :councillor="councillor"
    :partyColor="partyColor"
    :likedArticles="likedArticles"
    :pinnedArticles="pinnedArticles"
    :articles="articles"
    :pageCount="pageCount"
    :loading="loading"
    @fetchArticles="fetchArticles"
    @pinned="
      (type, reference, color) => $emit('pinned', type, reference, color)
    "
  />
</template>

<script>
import client from "api-client";

import TabNews from "./TabNews.vue";

export default {
  name: "CouncillorTabNews",
  components: {
    TabNews
  },
  props: {
    councillor: {
      type: Object,
      required: true
    },
    partyColor: {
      type: String,
      default: "black"
    },
    notepad: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    articles: [],
    loading: true,
    pageCount: 0
  }),
  computed: {
    likedArticles() {
      return this.notepad
        .filter(entry => entry.type === "councillor_article_like")
        .reduce(
          (acc, entry) =>
            Object.assign(acc, { [entry.reference]: entry.color }),
          {}
        );
    },
    pinnedArticles() {
      return this.notepad
        .filter(entry => entry.type === "councillor_article_pin")
        .reduce((acc, entry) => {
          return Object.assign(acc, { [entry.reference]: entry });
        }, {});
    }
  },
  methods: {
    async fetchArticles(id, filters) {
      this.loading = true;
      const res = await client.fetchCouncillorArticles(id, filters);
      this.articles = res.data;
      this.pageCount = res.last_page;
      this.loading = false;
    }
  }
};
</script>
